import React from 'react';
import PropTypes from 'prop-types';
import Buttonlet from '../../Buttonlet';

export default function ContactItem({ data, deleteContact }) {
  return (
    <li className="account__contact">
      <span>
        {data.userName}
      </span>
      <Buttonlet type="delete-contact" local onClick={deleteContact} />
    </li>
  );
}

ContactItem.displayName = 'ContactItem';

ContactItem.propTypes = {
  data: PropTypes.shape({
    userName: PropTypes.string.isRequired,
  }).isRequired,
  deleteContact: PropTypes.func.isRequired,
};